import React, { useState } from "react";
import { Check, Loader2 } from "lucide-react";
import { useNavigate } from "react-router-dom";
import apiService from "../../services/api";
import tokenManager from "../../utils/tokenManager";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [remember, setRemember] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSignUp = () => {
    navigate("/get-started");
  };

  const handleForgot = () => {
    navigate("/forgot-password");
  };

  const handleGoogleLogin = () => {
    window.location.href = `${
      process.env.REACT_APP_API_URL || "http://localhost:5000"
    }/api/auth/google`;
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  setError("");
  setLoading(true);

  try {
    const response = await apiService.login(email, password, remember);
    if (response.success) {
      navigate("/dashboard");
    }
  } catch (err) {
    console.error("Login error:", err);
    setError(err.response?.data?.message || "Failed to login. Please try again.");
  } finally {
    setLoading(false);
  }
  };
  return (
    <div className="auth-page">
      <img src="/assets/clockout2.png" alt="Clock-out" className="auth-logo" />

      <div className="auth-card">
        {/* Header */}
        <div className="text-center mb-7">
          <h1 className="auth-title">Welcome back</h1>
          <p className="auth-subtitle">Sign in to your account</p>
        </div>

        {/* Error Message */}
        {error && (
          <div className="mb-5 p-4 bg-red-50 border border-red-200 rounded-[12px]" role="alert">
            <p className="text-sm text-red-600">{error}</p>
          </div>
        )}

        {/* Login Form */}
        <form onSubmit={handleSubmit} className="space-y-4">
          {/* Email Field */}
          <div>
            <label className="auth-label" htmlFor="login-email">Email</label>
            <input
              id="login-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="auth-input"
              placeholder="you@company.com"
              autoComplete="email"
              required
              disabled={loading}
            />
          </div>

          {/* Password Field */}
          <div>
            <label className="auth-label" htmlFor="login-password">Password</label>
            <input
              id="login-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="auth-input"
              placeholder="••••••••"
              autoComplete="current-password"
              required
              disabled={loading}
            />
          </div>

          {/* Remember me and Forgot password */}
          <div className="flex items-center justify-between pt-1">
            <label className="flex items-center cursor-pointer select-none">
              <div className="relative flex">
                <input
                  type="checkbox"
                  checked={remember}
                  onChange={(e) => setRemember(e.target.checked)}
                  className="appearance-none w-[18px] h-[18px] rounded-[5px] border border-[#CDBE98] bg-white checked:bg-[#1C1A14] checked:border-[#1C1A14] transition-colors cursor-pointer"
                  disabled={loading}
                />
                {remember && (
                  <Check
                    size={12}
                    strokeWidth={3}
                    className="absolute top-[3px] left-[3px] text-[#FFC81E] pointer-events-none"
                  />
                )}
              </div>
              <span className="ml-2 text-sm text-[#4A4234]">Remember me</span>
            </label>
            <button type="button" className="auth-link" onClick={handleForgot} disabled={loading}>
              Forgot password?
            </button>
          </div>

          {/* Sign in Button */}
          <div className="pt-2">
            <button
              type="submit"
              disabled={loading || !email || !password}
              className="auth-btn-primary"
            >
              {loading ? (
                <>
                  <Loader2 className="animate-spin h-4 w-4" />
                  Signing in…
                </>
              ) : (
                "Sign in"
              )}
            </button>
          </div>
        </form>

        {/* Sign up */}
        <hr className="auth-divider" />
        <p className="mb-3 text-sm text-center text-[#645B4A]">New to Clock-out?</p>
        <button
          type="button"
          onClick={handleSignUp}
          disabled={loading}
          className="auth-btn-secondary"
        >
          Create an account
        </button>
      </div>

      {/* Footer */}
      <p className="auth-footer">
        © {new Date().getFullYear()} Talk Nerdy To Me Consultancy Ltd. All rights reserved.
      </p>
    </div>
  );
};

export default Login;